import React, {
    useState,
    forwardRef,
    useImperativeHandle,
    useEffect,
    Fragment,
    useCallback,
} from "react";
import {
    Grid,
    Select,
    MenuItem,
    Paper,
    makeStyles,
    Stepper,
    Step,
    StepLabel,
    Typography,
    Button,
    FormControl,
    TextField,
    CircularProgress,
    Tooltip,
} from "@material-ui/core";
import CustomTextField from "../../../components/Common/CustomTextField";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
    DateTimePicker,
} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import {
    addQueryInitialData,
    cargoFuelPriceStep,
    expenseResultField,
    fuelPriceOptions,
    loadlineOptions,
    portEmissionOptions,
    queryPortDisabledFields,
    termsCoEfficientTable,
    vesselCalculatorMainFields,
} from "../../../constants";
import DeleteIcon from "@material-ui/icons/Delete";
import * as actions from "./actions";
import {
    getCurrentUserOrganizationId,
    toastError,
    toastSuccess,
} from "../../../utils";
import moment from "moment";
import { useDispatch } from "react-redux";
import CustomShowModal from "../../../components/Common/CustomShowModal";
import AddPortQueryModal from "../../../components/Orders/AddPortQueryModal";
import * as commonActions from "../../Common/actions";
import { validateNewQuery } from "./addQueryValidation";
import { setCopyPortOperation, setCopyQuery } from "./dataMapping";
import DownloadPDF from "../../../components/Common/DowloadPDF";
import CargoPdf from "../../../components/Calculator/CargoPdf";
import { Document, PDFViewer, Page } from "@react-pdf/renderer";
import { handleKeyDown } from "../../../common/common";
import CustomButton from "../../../components/Common/CustomButton";
import UploadPDFModal from "../../../components/Common/UploadPDF";
import { GrDocumentPdf } from "react-icons/gr";
import { useParams } from "react-router-dom";
import Expenses from "../../../components/Calculator/Expenses";
import { Autocomplete } from "@material-ui/lab";
import { portsByChar } from "../Calculator/actions";
import { debounce } from "lodash";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    backButton: {
        marginRight: theme.spacing(1),
        background: "#fff"
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
}));

function getSteps() {
    return ['Disclaimer', 'Select Vessel Type', "Add Daily Hire Rates", " Vessel Opening Port and/or Ballast Factor", "Add Fuel Prices", "Port Expenses and Restricions"];
}

const CreateCargoAnalysis = forwardRef((props, ref) => {
    const {
        setLoader = () => { },
        onCloseModal = () => { },
        selectedQuery = {},
        selectedPorts = [],
        selectedPortsCommence = [],
        analysisVessel = [],
        setCargoAnalysisData,
        cargoAnalysisData,
        isEdit = false,
        // isDetailView = false,
        onChangePinQuery = () => { },
        isFromSingleVesselCalcy = false,
        getInitialData = () => { },
        setIsEdit,
        isOtherTab = false,
    } = props;
    const organizationId = getCurrentUserOrganizationId();

    const addPortInitialData = [
        {
            cargoId: "",
            operation: "Loading",
            port: "",
            cargoQty: 0,
            tolerance: 0,
            rate: 0,
            terms: "SHINC",
            turnTime: 0,
            pdaRemarks: "",
            grade: "",
            freight: 0,
            adcom: 0,
            other: 0,
            brokerage: 0,
            ttlComm: 0,
            netFrt: 0,
            min: 0,
            max: 0,
            account: "",
            cargo: "",
            factor: 1,
            stowFactor: 0,
            queryId: "",
            loadline: "S-Summer",
            sulfur: "Normal",
        },
        {
            cargoId: "",
            operation: "Discharging",
            port: "",
            cargoQty: 0,
            tolerance: 0,
            rate: 0,
            terms: "SHINC",
            turnTime: 0,
            pdaRemarks: "",
            grade: "",
            freight: 0,
            adcom: 0,
            other: 0,
            brokerage: 0,
            ttlComm: 0,
            netFrt: 0,
            min: 0,
            max: 0,
            account: "",
            cargo: "",
            factor: 1,
            stowFactor: 0,
            queryId: "",
            loadline: "S-Summer",
            sulfur: "Normal",
        },
    ];

    const dispatch = useDispatch();
    const [portOperations, setPortOperations] = useState([...addPortInitialData]);
    const [query, setQuery] = useState({ ...addQueryInitialData });
    const [portModal, setPortModal] = useState(false);
    const [selectedPort, setSelectedPort] = useState({});
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [getOpenUploadPDF, setOpenUploadPDF] = useState(false);
    const { id = "" } = useParams();
    const classes = useStyles();
    const [activeStep, setActiveStep] = useState(0);
    const [portLoading, setPortLoading] = useState(false);
    const [portOptions, setPortOptions] = useState([]);

    const steps = getSteps();

    useEffect(() => {
        if (Object.keys(selectedQuery).length) {
            setQuery(selectedQuery);
        }
        if (Array.isArray(selectedPorts) && selectedPorts.length) {
            setPortOperations(selectedPorts);
        }
        return () => {
            resetStateVariables();
        };
    }, [selectedQuery, selectedPorts]);

    useEffect(() => {
        const { errors } = validateNewQuery(query, portOperations);
        dispatch(commonActions.addOnlyErrors({ errorList: errors }));
    }, [query, portOperations]);
    const resetStateVariables = () => {
        setPortOperations([...addPortInitialData]);
        setQuery({ ...addQueryInitialData });
        // setStartDate(null)
        // setEndDate(null)
        setPortModal(false);
        setSelectedPort({});
        setSelectedIndex(0);
    };



    // useImperativeHandle(ref, () => ({
    const onSubmitQuery = async () => {
        setLoader(true);
        await actions
            .addCargoAnalysisDetails(cargoAnalysisData)
            .then((res) => {
                toastSuccess("Cargo analysis added successfully");
                onCloseModal();
                isOtherTab && window.open('/cargo-analysis')
                setLoader(false);
            })
            .catch(() => {
                setLoader(false);
            });
    }
    // }));

    const onChangePortOperation = (index, e) => {
        // if (isDetailView) return
        const { name = "", value = "", type = "" } = e.target;
        let updatedPortOperation = [...portOperations];
        updatedPortOperation[index][name] =
            type === "number" ? Number(value) : value;
        if (name === "terms") {
            const findFactor = termsCoEfficientTable.find(
                (item) => item.label === value
            );
            if (findFactor) {
                updatedPortOperation[index]["factor"] = findFactor.value;
            }
        }
        setPortOperations(updatedPortOperation);
    };




    const {
        qtyMode = "",
        fuelType = "TYPE0",
        lsFuelPriceType0 = 0,
        lsFuelPriceType1 = 0,
        lsFuelPriceType2 = 0,
        lsFuelPriceType3 = 0,
        lsFuelPriceType4 = 0,
        hsFuelPriceType0 = 0,
        hsFuelPriceType1 = 0,
        hsFuelPriceType2 = 0,
        hsFuelPriceType3 = 0,
        hsFuelPriceType4 = 0,
        mgoFuelPriceType0 = 0,
        mgoFuelPriceType1 = 0,
        mgoFuelPriceType2 = 0,
        mgoFuelPriceType3 = 0,
        mgoFuelPriceType4 = 0,
    } = cargoAnalysisData?.clientQuery || {};
    let fuelTypePrices = {
        TYPE0: {
            normal: hsFuelPriceType0 || 0,
            eca: lsFuelPriceType0 || 0,
            mgo: mgoFuelPriceType0 || 0,
        },
        TYPE1: {
            normal: hsFuelPriceType1 || 0,
            eca: lsFuelPriceType1 || 0,
            mgo: mgoFuelPriceType1 || 0,
        },
        TYPE2: {
            normal: hsFuelPriceType2 || 0,
            eca: lsFuelPriceType2 || 0,
            mgo: mgoFuelPriceType2 || 0,
        },
        TYPE3: {
            normal: hsFuelPriceType3 || 0,
            eca: lsFuelPriceType3 || 0,
            mgo: mgoFuelPriceType3 || 0,
        },
        TYPE4: {
            normal: hsFuelPriceType4 || 0,
            eca: lsFuelPriceType4 || 0,
            mgo: mgoFuelPriceType4 || 0,
        },
    };
    let showMinMax = false;
    if (qtyMode === "MINMAX") showMinMax = true;

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleNext = () => {
        if (activeStep === 1) {
            if (!cargoAnalysisData?.vessel) {
                return toastError("Please select vessel!")
            }
        }
        if (activeStep === 2) {
            if (!cargoAnalysisData?.vessel?.hirePerDay) {
                return toastError("Hire per day is required!")
            }
        }
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        if (activeStep === 5) {
            onSubmitQuery()
        }
    };
    const handleReset = () => {
        setActiveStep(0);
    };


    const onChangeFuelPrice = (e) => {
        const { name = "", value = "" } = e.target;
        let newClientQuery = cargoAnalysisData?.clientQuery
        const currentType = 0
        if (name === "normal") {
            newClientQuery[`hsFuelPriceType${currentType}`] = parseFloat(value);
        }
        if (name === "eca") {
            newClientQuery[`lsFuelPriceType${currentType}`] = parseFloat(value);
        }
        if (name === "mgo") {
            newClientQuery[`mgoFuelPriceType${currentType}`] = parseFloat(value);
        }
        newClientQuery.fuelType = "TYPE0"

        setCargoAnalysisData({
            ...cargoAnalysisData,
            clientQuery: newClientQuery

        });

    };
    const {
        vesselName = "",
        vesselDwt = 0,
        vesselIMO = 0,
        vesselBalSpd1 = 0,
        vesselBalConsmHS1 = 0,
        vesselBalConsmLS1 = 0,
        vesselBalConsmMGO1 = 0,
        vesselBalSpd2 = 0,
        vesselBalConsmHS2 = 0,
        vesselBalConsmLS2 = 0,
        vesselBalConsmMGO2 = 0,
        vesselBalSpd3 = 0,
        vesselBalConsmHS3 = 0,
        vesselBalConsmLS3 = 0,
        vesselBalConsmMGO3 = 0,
        vesselBalSpd4 = 0,
        vesselBalConsmHS4 = 0,
        vesselBalConsmLS4 = 0,
        vesselBalConsmMGO4 = 0,
        vesselLdnSpd1 = 0,
        vesselLdnConsmHS1 = 0,
        vesselLdnConsmLS1 = 0,
        vesselLdnConsmMGO1 = 0,
        vesselLdnSpd2 = 0,
        vesselLdnConsmHS2 = 0,
        vesselLdnConsmLS2 = 0,
        vesselLdnConsmMGO2 = 0,
        vesselLdnSpd3 = 0,
        vesselLdnConsmHS3 = 0,
        vesselLdnConsmLS3 = 0,
        vesselLdnConsmMGO3 = 0,
        vesselLdnSpd4 = 0,
        vesselLdnConsmHS4 = 0,
        vesselLdnConsmLS4 = 0,
        vesselLdnConsmMGO4 = 0,
        vesselPIdleConsmHS = 0,
        vesselPIdleConsmLS = 0,
        vesselPIdleConsmMGO = 0,
        vesselPLdgConsmHS = 0,
        vesselPLdgConsmLS = 0,
        vesselPLdgConsmMGO = 0,
        vesselPDischConsmHS = 0,
        vesselPDischConsmLS = 0,
        vesselPDischConsmMGO = 0,
        vesselVExtraConsmHS = 0,
        vesselVExtraConsmLS = 0,
        vesselVExtraConsmMGO = 0,
        vesselBalComb1Selected = false,
        vesselBalComb2Selected = false,
        vesselBalComb3Selected = false,
        vesselBalComb4Selected = false,
        vesselLadComb1Selected = false,
        vesselLadComb2Selected = false,
        vesselLadComb3Selected = false,
        vesselLadComb4Selected = false,
        vesselExtraDetails = {},
    } = cargoAnalysisData?.vessel?.vessel ? JSON.parse(cargoAnalysisData?.vessel?.vessel) : {};


    const handleChange = (event) => {
        setCargoAnalysisData({ ...cargoAnalysisData, vessel: event.target.value })
    };

    const handleChangeFields = (event) => {
        let cargoAnalysis = cargoAnalysisData.vessel
        setCargoAnalysisData({ ...cargoAnalysisData, vessel: { ...cargoAnalysis, [event.target.name]: event.target.value } })
    };

    const handleChangeFieldsDwf = (event) => {
        let clientQuery = cargoAnalysisData.clientQuery
        for (let i = 0; i < clientQuery?.cargoList?.length; i++) {
            clientQuery.cargoList[i].dwf = event.target.value
        }
        setCargoAnalysisData({ ...cargoAnalysisData, clientQuery: clientQuery })
    };


    const debouncedSearch = useCallback(
        debounce((search) => {
            onSearchPortList(search);
        }, 400),
        []
    );

    const delayPortsSearch = (search) => {
        setSelectedPort({ ...selectedPort, port: search });
        if (search?.length > 2)
            debouncedSearch(search);
    };

    const onSearchPortList = (value) => {

        if (value) {
            setPortLoading(true);
            portsByChar(value)
                .then((res) => {
                    setPortLoading(false);
                    let portList = [];
                    if (res.data.list?.length > 0) {
                        portList = res.data.list.map((item) => ({
                            label: `${item.name} ${item.country ? "(" + item.country + ")" : ""
                                }`,
                            value: item.name,
                            lat: item?.lat,
                            lng: item?.lng
                        }));
                    }
                    setPortOptions(portList);
                })
                .catch((err) => {
                    setPortLoading(false);
                    setPortOptions([]);
                });
        }
    };

    const onSelectPortsOfOperation = (value) => {
        setSelectedPort({ ...selectedPort, port: value.value });
        let cargoAnalysis = cargoAnalysisData.vessel
        setCargoAnalysisData({ ...cargoAnalysisData, vessel: { ...cargoAnalysis, port: value.value, lat: value.lat, lng: value.lng } })
    };

    let newPortOptions = [...portOptions];
    let selectedPortName = { label: "", value: "" };
    if (selectedPort.port) {
        // newPortOptions = [...portOptions, { label: selectedPort.port, value: selectedPort.port }]
        selectedPortName = { label: selectedPort.port, value: selectedPort.port };
    }


    const onChangeHandler = (e) => {
        const { name: key = "", value = "" } = e.target;
        let newCargoDetails = {};
        let clientQuery = cargoAnalysisData?.clientQuery
        if (key === "fuelType") {
            const currentType = 0
            newCargoDetails[`fuelPriceType${currentType}Hsfo`] = Number(
                clientQuery[`hsFuelPriceType${currentType}`]
            );
            newCargoDetails[`fuelPriceType${currentType}Lsfo`] = Number(
                clientQuery[`lsFuelPriceType${currentType}`]
            );
            newCargoDetails[`fuelPriceType${currentType}Mgo`] = Number(
                clientQuery[`mgoFuelPriceType${currentType}`]
            );
        }


        setCargoAnalysisData({
            ...cargoAnalysisData,
            clientQuery: {
                ...cargoAnalysisData.clientQuery,
                [key]: value,
            }
        });
    };

    // Shared classes for the Cargo Analysis steps, matching the Cargo Operations grid
    const ca = {
        title: "text-[11px] font-medium text-slate-900 capitalize tracking-wider border-l-4 border-l-[#313C4C] pl-2 leading-none py-0.5 m-0 mb-1.5",
        notes: "bg-[#f8fafc] border border-slate-200 p-2",
        noteText: "text-[11px] text-slate-600 leading-relaxed m-0",
        noteList: "list-disc pl-4 text-[11px] text-slate-600 leading-relaxed space-y-1 m-0",
        table: "w-full text-left border-collapse border border-slate-300",
        th: "px-2 py-1 text-left border-r border-b border-slate-300 text-[11px] font-medium text-slate-800 bg-slate-100 capitalize tracking-wider align-middle whitespace-nowrap",
        labelTd: "border border-slate-300 px-2 h-[24px] align-middle bg-[#f0f2f5] text-[11px] font-medium text-slate-900 whitespace-nowrap",
        td: "border border-slate-300 p-0 align-middle bg-white",
        input: "w-full h-[24px] text-[11px] px-2 py-0 m-0 box-border block outline-none bg-[#ffffd6] text-slate-900 focus:bg-white focus:ring-1 focus:ring-inset focus:ring-amber-600 rounded-none border-none font-medium tabular-nums [&[type=number]]:text-right",
    };

    function getStepContent(stepIndex) {
        switch (stepIndex) {
            case 0:
                return <div className="w-full px-2 py-2 text-left">
                    <div className={ca.notes}>
                        <h4 className={ca.title}>Before you start</h4>
                        <ul className={ca.noteList}>
                            <li>Cargo Analysis will evaluate the estimated freight for this cargo on the basis of user provided inputs.</li>
                            <li>Please note this is NOT a freight indication. You may end up getting a very different freight indication in the prevailing shipping markets.
                                Shipping markets are complex and freight level depends upon several factors including market sentiments, vessel availability, vessel preferences, regulatory regime, etc.</li>
                            <li>To be more clear, this is a freight calculation on a template vessel with the user given inputs. The purpose of this analysis is to give you a fair idea of the freight levels on a template vessel. The actual vessels in existence will have quite different characteristics and every ship owner may indicate his own workable freight number depending upon market condition and his own business acumen.</li>
                            <li>Primarily the freight is calculated basis the daily hire rate of ships, fuel prices, port expenses etc. On clicking next, we will guide you through the process to enter the values.</li>
                        </ul>
                    </div>
                    <div className="bg-amber-50 border border-amber-200 p-2 mt-2">
                        <p className="text-[11px] text-amber-800 leading-relaxed m-0">
                            Disclaimer : The system provider does not take any liability for any miscalculation. The user shall be solely responsible for all calculations and/or misinterpretation of the results, caused for whatsoever reasons.
                        </p>
                    </div>
                </div>

            case 1:
                return <Grid container className="add-order-container">
                    <Grid item xs={12} md={3} style={{ padding: 8 }}>
                        <div className="bg-[#f8fafc] border border-slate-200 p-2">
                            <h4 className="block text-[11px] font-medium text-slate-900 mb-1.5 capitalize tracking-wider border-l-4 border-l-[#313C4C] pl-2 leading-none py-0.5 m-0">Notes</h4>
                            <ul className="list-disc pl-4 text-[11px] text-slate-600 space-y-0.5 m-0">
                                <li>
                                    Please choose the most suitable vessel type from the drop down list. Although there are vessels available in the market for many sizes and dimensions, we have listed only the most prominent types. In reality, you may find vessels which do not fall in any of these categories.
                                </li>
                            </ul>
                        </div>
                    </Grid>
                    <Grid item xs={12} md={9} style={{ padding: 8 }}>

                        <div className="grid grid-cols-1 sm:grid-cols-4 gap-3 pb-4">
                            <div className="flex flex-col gap-1">
                                <label className="text-[11px] font-medium text-slate-700 capitalize tracking-wider">Select Vessel</label>
                                <FormControl style={{ width: "100%" }}>
                                    <Select
                                        value={cargoAnalysisData?.vessel || ""}
                                        onChange={handleChange}
                                        name="analysisVessel"
                                        size="small"
                                        variant="outlined"
                                        fullWidth
                                        className="!text-[11px] !rounded-none !bg-white !h-8 [&_.MuiSelect-root]:!text-[11px] [&_.MuiSelect-root]:!py-0 [&_.MuiSelect-root]:!px-2 [&_.MuiSelect-root]:!h-8 [&_.MuiSelect-root]:!leading-8 [&_.MuiOutlinedInput-notchedOutline]:!border-slate-300 [&_.MuiOutlinedInput-notchedOutline]:!rounded-none"
                                    >
                                            {analysisVessel?.map((item, i) => {
                                                return (
                                                    <MenuItem key={i} dense value={item} className="!text-[11px]">
                                                        {item?.vesselName}
                                                    </MenuItem>
                                                )
                                            })}


                                    </Select>
                                </FormControl>
                            </div>
                            {[
                                { label: "Vessel", name: "vesselName", value: vesselName },
                                { label: "DWT", name: "vesselDwt", value: vesselDwt },
                                { label: "IMO", name: "vesselIMO", value: vesselIMO },
                            ].map((field) => (
                                <div key={field.name} className="flex flex-col gap-1">
                                    <label className="text-[11px] font-medium text-slate-700 capitalize tracking-wider">{field.label}</label>
                                    <input
                                        disabled={true}
                                        value={field.value || ""}
                                        name={field.name}
                                        className="w-full h-8 px-2 text-[11px] border border-slate-300 rounded-none bg-slate-100 text-slate-700 outline-none"
                                    />
                                </div>
                            ))}
                        </div>
                        <div>

                            <Paper elevation={0} className="!shadow-none !rounded-none [&_.vessel-details-tables_th]:!bg-slate-100 [&_.vessel-details-tables_th]:!font-medium [&_.vessel-details-tables_th]:!text-slate-800 [&_.vessel-details-tables_th]:!whitespace-nowrap [&_.vessel-details-tables_td]:!whitespace-nowrap">
                                <Grid container>
                                    {/* <Grid item xs={12}>
                            <div className="d-flex">
                                <h4 className="result-heading" style={{ textDecoration: "underline" }}><Link to={`/vessel/${vessel.id}`} target="_blank" >Vessel Details</Link></h4>
                                <div><button color="primary" className="add-vessel-calculator" onClick={() => setOpen(true)}>+</button></div>
                            </div>
                        </Grid> */}

                                    <Grid item xs={12} md={5} className="!mb-3 md:!mb-0">
                                        <p className="mt-0 mb-1.5 text-[11px] font-medium text-slate-900 capitalize tracking-wider border-l-4 border-l-[#313C4C] pl-2 leading-none py-0.5">
                                            Vessel Particulars
                                        </p>
                                        <table className="fleet-result-table vesselDetails !w-full">

                                            <tbody>
                                                {vesselCalculatorMainFields.map((item, key) => {
                                                    if (
                                                        item.name === "fuelType"
                                                        // item.name === "vesselScrubber"
                                                    )
                                                        return (
                                                            <tr key={key}>
                                                                <th>{item.label}</th>
                                                                <td>
                                                                    <input
                                                                        value={"Type-1"}
                                                                        type={item.type}
                                                                        // onKeyDown={handleKeyDown}
                                                                        name={item.name}
                                                                    // onChange={onChangeHandler}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        );
                                                    return (
                                                        <tr key={key}>
                                                            <th>{item.label}</th>
                                                            <td>
                                                                <input
                                                                    value={cargoAnalysisData?.vessel?.vessel ? JSON.parse(cargoAnalysisData?.vessel?.vessel)?.[item.name] : ""}
                                                                    type={item.type}
                                                                    // onKeyDown={handleKeyDown}
                                                                    name={item.name}
                                                                    readOnly={true}
                                                                    onChange={(e) => {
                                                                        e.preventDefault(); // Prevent the default behavior of the input change
                                                                        e.stopPropagation();
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </Grid>
                                    <Grid item xs={12} md={7} className="md:!pl-3">
                                        <Grid container>
                                            <Grid item xs={12}>
                                                <p className="mt-0 mb-1.5 text-[11px] font-medium text-slate-900 capitalize tracking-wider border-l-4 border-l-[#313C4C] pl-2 leading-none py-0.5">
                                                    Ballast Sea Consumptions
                                                </p>
                                                <table className="vessel-details-tables">
                                                    <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th>Speed</th>
                                                            <th>Main</th>
                                                            <th>ECA</th>
                                                            <th>MGO</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    className="input-type-checkbox"
                                                                    name="vesselBalComb1Selected"
                                                                    checked={vesselBalComb1Selected || false}
                                                                // onChange={(e) => onChangeHandler(e, false, true)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalSpd1"
                                                                    value={vesselBalSpd1 || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmHS1"
                                                                    value={vesselBalConsmHS1 || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmLS1"
                                                                    value={vesselBalConsmLS1 || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmMGO1"
                                                                    value={vesselBalConsmMGO1 || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    className="input-type-checkbox"
                                                                    name="vesselBalComb2Selected"
                                                                    checked={vesselBalComb2Selected || false}
                                                                // onChange={onChangeHandler}
                                                                // onChange={(e) => onChangeHandler(e, false, true)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalSpd2"
                                                                    value={vesselBalSpd2 || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmHS2"
                                                                    value={vesselBalConsmHS2 || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmLS2"
                                                                    value={vesselBalConsmLS2 || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmMGO2"
                                                                    value={vesselBalConsmMGO2 || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    className="input-type-checkbox"
                                                                    name="vesselBalComb3Selected"
                                                                    checked={vesselBalComb3Selected || false}
                                                                // onChange={onChangeHandler}
                                                                // onChange={(e) => onChangeHandler(e, false, true)}

                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalSpd3"
                                                                    value={vesselBalSpd3 || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmHS3"
                                                                    value={vesselBalConsmHS3 || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmLS3"
                                                                    value={vesselBalConsmLS3 || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmMGO3"
                                                                    value={vesselBalConsmMGO3 || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    className="input-type-checkbox"
                                                                    name="vesselBalComb4Selected"
                                                                    checked={vesselBalComb4Selected || false}
                                                                // onChange={onChangeHandler}
                                                                // onChange={(e) => onChangeHandler(e, false, true)}

                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalSpd4"
                                                                    value={vesselBalSpd4 || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmHS4"
                                                                    value={vesselBalConsmHS4 || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmLS4"
                                                                    value={vesselBalConsmLS4 || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmMGO4"
                                                                    value={vesselBalConsmMGO4 || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <p className="mt-3 mb-1.5 text-[11px] font-medium text-slate-900 capitalize tracking-wider border-l-4 border-l-[#313C4C] pl-2 leading-none py-0.5">
                                                    Laden Sea Consumptions
                                                </p>
                                                <table className="vessel-details-tables">
                                                    <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th>Speed</th>
                                                            <th>Main</th>
                                                            <th>ECA</th>
                                                            <th>MGO</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    className="input-type-checkbox"
                                                                    name="vesselLadComb1Selected"
                                                                    checked={vesselLadComb1Selected || false}
                                                                // onChange={onChangeHandler}
                                                                // onChange={(e) => onChangeHandler(e, false, true)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnSpd1"
                                                                    value={vesselLdnSpd1 || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmHS1"
                                                                    value={vesselLdnConsmHS1 || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmLS1"
                                                                    value={vesselLdnConsmLS1 || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmMGO1"
                                                                    value={vesselLdnConsmMGO1 || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    className="input-type-checkbox"
                                                                    name="vesselLadComb2Selected"
                                                                    checked={vesselLadComb2Selected || false}
                                                                // onChange={onChangeHandler}
                                                                // onChange={(e) => onChangeHandler(e, false, true)}

                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnSpd2"
                                                                    value={vesselLdnSpd2 || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmHS2"
                                                                    value={vesselLdnConsmHS2 || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmLS2"
                                                                    value={vesselLdnConsmLS2 || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmMGO2"
                                                                    value={vesselLdnConsmMGO2 || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    className="input-type-checkbox"
                                                                    name="vesselLadComb3Selected"
                                                                    checked={vesselLadComb3Selected || false}
                                                                // onChange={onChangeHandler}
                                                                // onChange={(e) => onChangeHandler(e, false, true)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnSpd3"
                                                                    value={vesselLdnSpd3 || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmHS3"
                                                                    value={vesselLdnConsmHS3 || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmLS3"
                                                                    value={vesselLdnConsmLS3 || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmMGO3"
                                                                    value={vesselLdnConsmMGO3 || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    className="input-type-checkbox"
                                                                    name="vesselLadComb4Selected"
                                                                    checked={vesselLadComb4Selected || false}
                                                                // onChange={onChangeHandler}
                                                                // onChange={(e) => onChangeHandler(e, false, true)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnSpd4"
                                                                    value={vesselLdnSpd4 || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmHS4"
                                                                    value={vesselLdnConsmHS4 || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmLS4"
                                                                    value={vesselLdnConsmLS4 || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmMGO4"
                                                                    value={vesselLdnConsmMGO4 || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <p className="mt-3 mb-1.5 text-[11px] font-medium text-slate-900 capitalize tracking-wider border-l-4 border-l-[#313C4C] pl-2 leading-none py-0.5">
                                                    Port Consumptions
                                                </p>
                                                <table className="vessel-details-tables">
                                                    <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th>Main</th>
                                                            <th>ECA</th>
                                                            <th>MGO</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <th>Idle</th>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselPIdleConsmHS"
                                                                    value={vesselPIdleConsmHS || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselPIdleConsmLS"
                                                                    value={vesselPIdleConsmLS || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselPIdleConsmMGO"
                                                                    value={vesselPIdleConsmMGO || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th>Loading</th>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselPLdgConsmHS"
                                                                    value={vesselPLdgConsmHS || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselPLdgConsmLS"
                                                                    value={vesselPLdgConsmLS || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselPLdgConsmMGO"
                                                                    value={vesselPLdgConsmMGO || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th>Disch</th>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselPDischConsmHS"
                                                                    value={vesselPDischConsmHS || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselPDischConsmLS"
                                                                    value={vesselPDischConsmLS || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselPDischConsmMGO"
                                                                    value={vesselPDischConsmMGO || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <Tooltip placement="top" arrow title={<span className="text-sm">Any Additional Lupsum Consumption in the entire voyage</span>}>
                                                                <th>Extra</th>
                                                            </Tooltip>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselVExtraConsmHS"
                                                                    value={vesselVExtraConsmHS || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselVExtraConsmLS"
                                                                    value={vesselVExtraConsmLS || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselVExtraConsmMGO"
                                                                    value={vesselVExtraConsmMGO || ""}
                                                                // onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Paper>
                        </div>
                    </Grid>

                </Grid>
            case 2:
                return <div className="w-full grid grid-cols-1 md:grid-cols-12 gap-4 px-2 py-2 text-left">
                    <div className="md:col-span-4 flex flex-col gap-2">
                        <h4 className={ca.title}>Daily Hire Rate</h4>
                        <table className={ca.table}>
                            <tbody>
                                <tr>
                                    <td className={ca.labelTd}>Hire Per Day</td>
                                    <td className={ca.td}>
                                        <input
                                            value={cargoAnalysisData?.vessel?.hirePerDay}
                                            type="number"
                                            onKeyDown={handleKeyDown}
                                            name={"hirePerDay"}
                                            onChange={handleChangeFields}
                                            placeholder="0"
                                            className={ca.input}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="md:col-span-8">
                        <div className={ca.notes}>
                            <h4 className={ca.title}>Notes</h4>
                            <p className={ca.noteText}>
                                Generally speaking, ships are highly capital intensive assets. Ship-owners strive to achieve the shortest payback period for their investments, thus they try to squeeze the best possible hire rate (i.e. Hire Per Day)  from the market. Ultimately it is a demand supply tussle which decides the final price, as a result of long bargaining and negotiations of the stakeholders. Albeit it is very difficult to guess at what hire rates, the ships are available, a cue may be taken from the daily published indices for the dry bulk market.
                            </p>
                            <p className={`${ca.noteText} mt-1.5`}>
                                The published indices are applicable for the pre-defined routes, which may or may not coincide with desired cargo route, however you may carry your own statistical analysis to find any correlation between any one published routes and desired routes. If you have a good amount of past data points, you may derive your own alpha (α) and beta (ß) and apply it to the index hire to obtain your current route hire. (Beware of the Statistical fallacies)
                                Please be aware the actual market scenario is highly dependent upon localised market conditions and may bear no relation with the index hires, however statistics may hold true sometimes in  deeper and matured markets.
                            </p>
                            <p className={`${ca.noteText} mt-1.5`}>
                                For a better understanding, please refer our help section.
                            </p>
                        </div>
                    </div>
                </div>
            case 3:
                return <div className="w-full grid grid-cols-1 md:grid-cols-12 gap-4 px-2 py-2 text-left">
                    <div className="md:col-span-5 flex flex-col gap-2">
                        <h4 className={ca.title}>Opening Port and Ballast Factor</h4>
                        <table className={ca.table}>
                            <tbody>
                                <tr>
                                    <td className={`${ca.labelTd} w-[45%]`}>Vessel Opening Port</td>
                                    <td className={ca.td}>
                                        <Autocomplete
                                            options={
                                                portLoading || portOptions.length === 0 ? [] : newPortOptions
                                            }
                                            value={selectedPortName}
                                            disableClearable
                                            getOptionLabel={(option) => option.label}
                                            onChange={(e, value) => onSelectPortsOfOperation(value)}
                                            getOptionSelected={(option, value) => option.value === value.value}
                                            noOptionsText={portLoading ? "Searching…" : "Type to search ports"}
                                            classes={{ option: "!text-[11px] !py-1 !px-2", paper: "!rounded-none !border !border-slate-300", noOptions: "!text-[11px] !text-slate-500 !px-2 !py-2" }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    autoFocus
                                                    variant="outlined"
                                                    placeholder="Search Ports"
                                                    value={cargoAnalysisData?.vessel?.port}
                                                    onChange={(e) => delayPortsSearch(e.target.value)}
                                                    size="small"
                                                    className="[&_.MuiOutlinedInput-root]:!rounded-none [&_.MuiOutlinedInput-root]:!h-[24px] [&_.MuiOutlinedInput-root]:!py-0 [&_.MuiOutlinedInput-root]:!pl-2 [&_.MuiOutlinedInput-root]:!bg-[#ffffd6] [&_.MuiOutlinedInput-root]:!text-[11px] [&_.MuiOutlinedInput-input]:!p-0 [&_.MuiOutlinedInput-input]:!h-[24px] [&_.MuiOutlinedInput-input]:!bg-transparent [&_.MuiOutlinedInput-input]:!border-none [&_.MuiOutlinedInput-input]:!shadow-none [&_.MuiOutlinedInput-input]:!outline-none [&_.MuiOutlinedInput-input]:!text-[11px] [&_.MuiOutlinedInput-notchedOutline]:!border-none [&_.MuiAutocomplete-endAdornment]:!top-1/2 [&_.MuiAutocomplete-endAdornment]:!-translate-y-1/2 [&_.MuiAutocomplete-endAdornment]:!right-1 [&_.MuiAutocomplete-popupIndicator]:!p-0"
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <React.Fragment>
                                                                {portLoading ? (
                                                                    <CircularProgress color="inherit" size={14} />
                                                                ) : null}
                                                                {params.InputProps.endAdornment}
                                                            </React.Fragment>
                                                        ),
                                                    }}
                                                />
                                            )}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td className={ca.labelTd}>Ballast Factor</td>
                                    <td className={ca.td}>
                                        <input
                                            value={cargoAnalysisData?.clientQuery?.cargoList[0]?.dwf}
                                            type="number"
                                            onKeyDown={handleKeyDown}
                                            name={"dwf"}
                                            onChange={handleChangeFieldsDwf}
                                            placeholder="0"
                                            className={ca.input}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="md:col-span-7">
                        <div className={ca.notes}>
                            <h4 className={ca.title}>Notes</h4>
                            <ul className={ca.noteList}>
                                <li>
                                    <span className="text-slate-900">Vessel Opening Port:</span> Please select the most prominent vessel opening port near to the loading port. If you are not sure, please select loading port, and give some value to Ballast Factor.
                                </li>
                                <li>
                                    <span className="text-slate-900">Ballast Factor:</span> You may choose some ballast factor (%) to give it the same impact as the ballasting distance of the vessel from opening port to loading port. If not sure about this, we recommend 33%. Ultimately, the combination of Daily Hire Rate, Vessel opening port, Ballast Factor, Fuel Prices, Port Expenses and other expenses should determine the freight rate for this cargo order.
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            case 4:
                return <div className="w-full grid grid-cols-1 md:grid-cols-12 gap-4 px-2 py-2 text-left">
                    <div className="md:col-span-5 flex flex-col gap-2">
                        <h4 className={ca.title}>Fuel Prices</h4>
                        <table className={ca.table}>
                            <thead>
                                <tr>
                                    <th className={`${ca.th} w-[28%]`}>Type</th>
                                    <th className={ca.th}>Main</th>
                                    <th className={ca.th}>ECA</th>
                                    <th className={ca.th}>MGO</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className={ca.td}>
                                        <select
                                            value={fuelType}
                                            name="fuelType"
                                            className={`${ca.input} !bg-[#f0f2f5] appearance-none cursor-not-allowed`}
                                            onChange={onChangeHandler}
                                            disabled
                                        >
                                            {fuelPriceOptions.map((item, index) => {
                                                return (
                                                    <option key={index} value={item.value}>
                                                        {item.label}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                    </td>
                                    {["normal", "eca", "mgo"].map((type) => (
                                        <td key={type} className={ca.td}>
                                            <input
                                                type="number"
                                                onKeyDown={handleKeyDown}
                                                placeholder="0"
                                                name={type}
                                                onChange={onChangeFuelPrice}
                                                value={fuelTypePrices?.[fuelType]?.[type]}
                                                className={ca.input}
                                            />
                                        </td>
                                    ))}
                                </tr>
                            </tbody>
                        </table>

                        <h4 className={`${ca.title} mt-3`}>Deadweight Deductibles</h4>
                        <table className={ca.table}>
                            <tbody>
                                <tr>
                                    <td className={`${ca.labelTd} w-[55%]`}>Deductibles for cargo carriage</td>
                                    <td className={ca.td}>
                                        <input
                                            value={cargoAnalysisData?.vessel?.bnkDelhs}
                                            type="number"
                                            onKeyDown={handleKeyDown}
                                            name={"bnkDelhs"}
                                            onChange={handleChangeFields}
                                            placeholder="0"
                                            className={ca.input}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="md:col-span-7">
                        <div className={ca.notes}>
                            <h4 className={ca.title}>Notes</h4>
                            <ul className={ca.noteList}>
                                <li>HS (Normal) : Price for the fuel used in 0.5% emission Area</li>
                                <li>LS (ECA) : Price for the fuel used in 0.1% emissioin area</li>
                                <li>MGO : Price for the light fuel needed on board</li>
                                <li>(Generally MGO consumption is miniscule, so you may skip this for estimate purpose)</li>
                                <li>Deductibles: This quantity will be deducted from deadweight to find loadability.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            case 5:
                return <div className="w-full flex flex-col gap-2 px-2 py-2 text-left">
                    <h4 className={ca.title}>Port Expenses and Port Restrictions</h4>
                    <div className={ca.notes}>
                        <p className={ca.noteText}>
                            Please enter approximate Port Expenses and other port restrictions in this table. The system will automatically apply these costs and restrictions to calculate the voyage cost, cargo loadability, and thus derive the freight Per Metric Ton.
                        </p>
                    </div>
                    <div className="overflow-x-auto w-full">
                        <table className={`${ca.table} whitespace-nowrap`}>
                            <thead>
                                <tr>
                                    {["Operation", "Port", "Extra Days", "Port Exp", "Port Emission", "Loadline", "Draft Restriction", "Water Density"].map((head) => (
                                        <th key={head} className={ca.th}>{head}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {portOperations.map((item, index) => {
                                    const {
                                        operation = "",
                                        port = "",
                                        extraDays = "",
                                        waterDensity = "",
                                        draftRes,
                                        portExp = ""
                                    } = item || {};
                                    item.sulfur = item.sulfur ? item.sulfur : "Normal"
                                    item.loadline = item.loadline ? item.loadline : "loadline"
                                    return (
                                        <tr key={index}>
                                            <td className={`${ca.labelTd} ${operation.toLowerCase() === "discharging" ? "!text-rose-700" : ""}`}>{operation}</td>
                                            <td className={ca.labelTd}>{port}</td>
                                            <td className={ca.td}>
                                                <input type="number" onKeyDown={handleKeyDown} value={extraDays} name="extraDays"
                                                    onChange={(e) => onChangePortOperation(index, e)} placeholder="0" className={ca.input} />
                                            </td>
                                            <td className={ca.td}>
                                                <input type="number" onKeyDown={handleKeyDown} value={portExp} name="portExp"
                                                    onChange={(e) => onChangePortOperation(index, e)} placeholder="0" className={ca.input} />
                                            </td>
                                            <td className={ca.td}>
                                                <select name="sulfur" value={item.sulfur}
                                                    onChange={(e) => onChangePortOperation(index, e)} className={`${ca.input} cursor-pointer`}>
                                                    {portEmissionOptions.map((opt, i) => (
                                                        <option key={i} value={opt.label}>{opt.label}</option>
                                                    ))}
                                                </select>
                                            </td>
                                            <td className={ca.td}>
                                                <select name="loadline" value={item?.loadline}
                                                    onChange={(e) => onChangePortOperation(index, e)} className={`${ca.input} cursor-pointer`}>
                                                    {loadlineOptions.map((opt, i) => (
                                                        <option key={i} value={opt.label}>{opt.label}</option>
                                                    ))}
                                                </select>
                                            </td>
                                            <td className={ca.td}>
                                                <input type="number" onKeyDown={handleKeyDown} value={draftRes} name="draftRes"
                                                    onChange={(e) => onChangePortOperation(index, e)} placeholder="0" className={ca.input} />
                                            </td>
                                            <td className={ca.td}>
                                                <input type="number" onKeyDown={handleKeyDown} value={waterDensity} name="waterDensity"
                                                    onChange={(e) => onChangePortOperation(index, e)} placeholder="0" className={ca.input} />
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            default:
                return 'Unknown stepIndex';

        }
    }
    return (
        <Fragment>
            <div className="mb-4 flex justify-end w-full">
                <div className={classes.root}>
                    <Stepper activeStep={activeStep} className="stepper-background" style={{ background: "fff" }} alternativeLabel>
                        {steps.map((label) => (
                            <Step style={{ background: "fff" }} key={label}>
                                <StepLabel style={{ background: "fff" }}><span className="hidden md:inline">{label}</span></StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                    {activeStep < steps.length && (
                        <div className="md:hidden text-center text-[11px] font-medium text-slate-900 -mt-1 mb-2">
                            Step {activeStep + 1} of {steps.length}: {steps[activeStep].trim()}
                        </div>
                    )}
                    <div>
                        {activeStep === steps.length ? (
                            <div>
                                <Typography className={classes.instructions}>All steps completed</Typography>
                                <Button onClick={handleReset}>Reset</Button>
                            </div>
                        ) : (
                            <div>
                                <Typography className={classes.instructions} style={{ display: "flex", justifyContent: "center" }}>{getStepContent(activeStep)}</Typography>
                                <div className="flex justify-end items-center gap-2.5 pt-2">
                                    <button
                                        onClick={activeStep == 0 ? onCloseModal : handleBack}
                                        className="h-[28px] px-3.5 text-[11px] font-medium text-slate-900 bg-white hover:bg-slate-100 border border-slate-300 rounded-none shadow-2xs transition-colors capitalize tracking-wider cursor-pointer"
                                    >
                                        {activeStep == 0 ? "Don't Agree!" : "Back"}
                                    </button>
                                    <button
                                        onClick={handleNext}
                                        className="h-[28px] px-3.5 text-[11px] font-medium text-white bg-[#313C4C] hover:bg-[#1e2632] border border-[#313C4C] rounded-none shadow-2xs transition-colors capitalize tracking-wider cursor-pointer"
                                    >
                                        {activeStep == 0 ? "Okay, I understand" : activeStep === steps.length - 1 ? "Finish" : "Next"}
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>

        </Fragment>
    );
});

export default CreateCargoAnalysis;
